// Единый источник геометрии брендового лоадера-дуги.
// Используется и React-компонентом <Loader> (обе платформы), и pre-React
// splash-спиннером в packages/web/index.html — туда SVG вшивает Vite-плагин
// (staticSplashSpinnerPlugin) на билде из этого же модуля, чтобы у сплэша и
// лоадера приложения не было рассинхрона.
//
// ВАЖНО: файл не должен тянуть React / react-native / theme / scale — его
// импортирует Node-код Vite-конфига. Только чистые константы и сборка строки.

export const LOADER_ARC = {
  viewBoxSize: 100,
  radius: 30,
  strokeWidth: 8,
  dashArray: '50 360',
  rotationDeg: 720,
  durationMs: 2100,
} as const

/**
 * Разметка splash-спиннера (pre-React) как строка — для инжекта в index.html.
 * Цвет через `var(--color-primary)` (тема проставляется inline-скриптом в <head>).
 * Анимация вращения задаётся CSS-классом в index.html (см. `#static-splash .spinner`,
 * значения rotation/duration зеркалят LOADER_ARC).
 */
export function buildSplashSpinnerSvg(className = 'spinner'): string {
  const { viewBoxSize, radius, strokeWidth, dashArray } = LOADER_ARC
  const center = viewBoxSize / 2

  return (
    `<svg class="${className}" viewBox="0 0 ${viewBoxSize} ${viewBoxSize}" xmlns="http://www.w3.org/2000/svg">` +
    `<circle cx="${center}" cy="${center}" r="${radius}" fill="none" stroke="var(--color-primary)" ` +
    `stroke-width="${strokeWidth}" stroke-dasharray="${dashArray}" stroke-linecap="round" />` +
    `</svg>`
  )
}
